import Swup from "swup";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import SwupGaPlugin from "@swup/ga-plugin";
import FragmentPlugin from "@swup/fragment-plugin";

import randomLogos from "./modules/randomLogos";
import eyesInSVGs from "./modules/eyesInSVGs";
import videos from "./modules/videos";
import processAnimation from "./modules/processAnimation";
import projectFilters from "./modules/projectFilters";
import accordions from "./modules/accordions";
import Canvas404 from "./modules/Canvas404";
import testimonialCarousel from "./modules/testimonialCarousel";
import caseStudyReadMore from "./modules/caseStudyReadMore";
import servicesCarousel from "./modules/servicesCarousel";
import headerScroll from "./modules/headerScroll";
import basicIntersections from "./modules/basicIntersections";
import buttons from "./modules/buttons";
import IconAnimations from "./modules/IconAnimations";
import Arcade from "./modules/arcade";
import menu from "./modules/menu";
import arcade from "./modules/arcade";
import { workFilterRules } from "./modules/projectFilters";
import marqueeDrags from "./modules/marqueeDrags";
import stickyCTA from "./modules/stickyCTA";
import teamToggle from "./modules/teamToggle";

import cookies from "./modules/cookies";

function swupActiveLinks() {
  let currentPath = window.location.pathname;
  let links = document.querySelectorAll(".header-nav a, .header--inline-nav a"); // <- put your link selector here
  for (const link of links) {
    let linkPath = new URL(link.href).pathname;
    link.ariaCurrent = linkPath == currentPath ? "page" : false;
  }

  Array.from(document.querySelectorAll(".work-filters--nav a")).forEach(
    (link) => {
      const linkPath = new URL(link.href).pathname;
      link.classList.toggle("is-active", linkPath === currentPath);
    },
  );
}
swupActiveLinks();
headerScroll.init();
menu.init();
cookies.init();

function init() {
  // console.log(`init()`);

  buttons.init();
  basicIntersections.init();
  processAnimation.init();
  servicesCarousel.init();
  testimonialCarousel.init();
  randomLogos.init();
  caseStudyReadMore.init();
  projectFilters.init();
  accordions.init();
  videos.init();
  Canvas404.init();
  IconAnimations.init();
  Arcade.init();
  marqueeDrags.init();
  eyesInSVGs.init();
  swupActiveLinks();
  stickyCTA.init();
  teamToggle.init();
  cookies.check();
}

function unLoad() {
  buttons.destroy();
  basicIntersections.destroy();
  processAnimation.destroy();
  servicesCarousel.destroy();
  testimonialCarousel.destroy();
  randomLogos.destroy();
  caseStudyReadMore.destroy();
  projectFilters.destroy();
  accordions.destroy();
  videos.destroy();
  Canvas404.destroy();
  IconAnimations.destroy();
  arcade.destroy();
  marqueeDrags.destroy();
  eyesInSVGs.destroy();
  teamToggle.destroy();
}

document.addEventListener(
  "DOMContentLoaded",
  function () {
    let wpAdminBar = document.getElementById("wpadminbar");
    let admin = !!wpAdminBar;
    if (admin) {
      return init();
    }
    const fragmentPlugin = new FragmentPlugin({
      rules: workFilterRules,
    });

    const swup = new Swup({
      animateHistoryBrowsing: true,
      plugins: [
        new SwupBodyClassPlugin(),
        new SwupGaPlugin({ gaMeasurementId: "G-EXTNC0EYMK" }),
        fragmentPlugin,
      ],
      ignoreVisit: (url) => {
        return url.includes("/project-scope/");
      },
    });

    swup.hooks.on("animation:out:start", () => {});

    swup.hooks.on("content:replace", () => {
      init();
      swupActiveLinks();
      menu.destroy();
    });

    swup.hooks.on("animation:out:end", (visit) => {
      document.querySelector("body").classList.remove("menu-open");
      unLoad();
      const fragmentVisit = fragmentPlugin.getFragmentVisit({
        from: visit.from.url,
        to: visit.to.url,
      });

      if (!fragmentVisit) {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      }
    });
    init();
  },
  false,
);
